import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { FieldFooter } from '../FieldFooter';
import { RadioButton, RadioLabel, Wrapper } from './RadioButton.styles';
export const RadioInput = /*#__PURE__*/ forwardRef(({ className, hasBoldLabel, hasError, isDisabled, label, name, statusLabel, value, ...props }, ref)=>/*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ _jsx(RadioButton, {
                disabled: isDisabled,
                id: `${name}-${value}`,
                name: name,
                type: "radio",
                value: value.toString(),
                ...props,
                $state: hasError ? 'error' : isDisabled ? 'disabled' : 'default',
                ref: ref
            }),
            /*#__PURE__*/ _jsxs(RadioLabel, {
                $isDisabled: isDisabled,
                htmlFor: `${name}-${value}`,
                isBold: hasBoldLabel,
                children: [
                    label,
                    /*#__PURE__*/ _jsx(FieldFooter, {
                        fieldFooterLabel: statusLabel,
                        fieldFooterType: hasError ? 'error' : 'default'
                    })
                ]
            })
        ]
    }));

//# sourceMappingURL=RadioInput.js.map